import { EnrolledUsersOption, UserItemDtoPaginatedList } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListUsersDrawer } from 'views/foundation/user/drawers/ListUsersDrawer';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    option: EnrolledUsersOption;
    title?: string;
    subtitle?: string;
    trainingId: string;
    classroomId?: string | null;
    onClose: () => void;
}

////////////////////////////////////////////////////////////////////////////

export const TrainingListUsersDrawer: React.FC<IProps> = ({ option, title, subtitle, trainingId, classroomId, onClose }) => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");

    return <ListUsersDrawer
        title={title ??
            option == EnrolledUsersOption.Active
            ? t("Training.TrainingListUsersDrawer.Active")
            : option == EnrolledUsersOption.Enrolled
                ? t("Training.TrainingListUsersDrawer.Enrolled")
                : option == EnrolledUsersOption.Completed
                    ? t("Training.TrainingListUsersDrawer.Enrolled")
                    : undefined
        }
        subtitle={subtitle}
        onGetData={
            ({ searchText, pageNumber, pageSize }, signal) =>
                new Promise<UserItemDtoPaginatedList>((resolve, reject) => {
                    api.v1.enrollment.getEnrolledUsers({
                        searchText,
                        pageNumber,
                        pageSize,
                        trainingId: trainingId,
                        classroomId: classroomId || null,
                        option
                    }, { signal })
                        .then(result => resolve(result.data))
                        .catch(e => reject(e));
                })
        }
        onClose={onClose}
    />;

};

